<div mat-dialog-content>
    <section class="listing-categories-area pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-1" style="margin-top: 20px">
                    <img
                        src="assets/img/avatar.jpg"
                        class="avatar"
                        alt="image"
                        width="60px"
                    />
                </div>

                <div class="col-lg-11" style="margin-top: 20px">
                    <p class="comment-form-comment textarea-container">
                        <textarea
                            name="comment"
                            id="comment"
                            cols="45"
                            placeholder="رسالتك..."
                            rows="5"
                            maxlength="65525"
                            required="required"
                            [(ngModel)]="message"
                        ></textarea>
                    </p>
                </div>

                <div class="col-lg-12 col-md-12">
                    <div class="form-group mb-3">
                        <label
                            >{{ "إرسال ملف"}}
                            <span>*</span></label
                        >

                        <input
                            class="form-control inp-file"
                            type="file"
                            name="txtMedicalReport"
                            id="txtMedicalReport"
                            (change)="onChangeFile($event)"
                        />
                    </div>
                </div>

                <div class="comments-area">
                    <h3 class="comments-title">الرسائل :</h3>

                    <ol class="comment-list">
                        <li class="comment">
                            <article class="comment-body">
                                <footer class="comment-meta">
                                    <div class="comment-author vcard">
                                        <img
                                            src="assets/img/avatar.jpg"
                                            class="avatar"
                                            alt="image"
                                        />
                                        <b class="fn">إدارة استقبال الطلبات</b>
                                        <span class="says">ترسل:</span>
                                    </div>

                                    <div class="comment-metadata">
                                        <a routerLink="/">
                                            <span>
                                                {{
                                                    data.booking.created_at
                                                        | date: "dd/MM/yyyy"
                                                }}
                                            </span>
                                        </a>
                                    </div>
                                </footer>

                                <div class="comment-content">
                                    <p>{{ data.booking.umessage }}.</p>
                                </div>
                            </article>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </section>
</div>
<div mat-dialog-actions>
    <div class="row-flex" style="margin-bottom: 5px">
        <button mat-button (click)="confirm()">Save</button>
        <button mat-button (click)="cancel()">Close</button>
        <div class="flex-space"></div>
    </div>
</div>
